import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useChangeVisibilityForVerkaeuferMutation, useGetEigeneAuftraegeMutation } from '../../api/AuftragAPI';
import { useGetAuftragTableOrderServiceMutation, useSetAuftragTableOrderServiceMutation } from '../../api/ProfileAPI';
import { LoadingModal } from '../../component/LoadingModal/LoadingModal';
import ScrollToTopBadge from '../../component/ScrollToTop';
import { IAuftragAgAnsicht, IAuftragTableOrderColumns } from '../../types/Types';
import { formatToEuroDate, getWochentagUtil } from '../../util/DateUtils';

/**
 * @author noone
 */
export type IEigeneAuftraegeListeProps = {
  statusChanged: () => void;
}

export default function EigeneAuftraegeListe(props: IEigeneAuftraegeListeProps) {

  const { t } = useTranslation();

  const [getProfileParameter] = useGetAuftragTableOrderServiceMutation();
  const [setProfileParameter] = useSetAuftragTableOrderServiceMutation();
  const [eigeneauftraegeAPI] = useGetEigeneAuftraegeMutation();
  const [changeVisibilityAPI] = useChangeVisibilityForVerkaeuferMutation();

  const [liste, setListe] = useState<IAuftragAgAnsicht[]>([]);
  const [originalListe, setOriginalListe] = useState<IAuftragAgAnsicht[]>([]);
  const [sortList, setSortList] = useState(new Map<number, number>());
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const navigate = useNavigate();

  const sort = (number: number) => {
    sortList.forEach((value, key) => {
      if (key !== number) {
        sortList.set(key, 0);
      } else {
        if (value === 0) {
          sortList.set(key, 1);
        } else if (value === 1) {
          sortList.set(key, -1);
        } else {
          sortList.set(key, 0);
        }
      }
    });
    sortListeByColumn(number);

    saveColumnOrder();
  }

  const sortListeByColumn = (column: number) => {
    liste.sort((a, b) => {
      if (column === 1) {
        if (sortList.get(column) === 1) {
          return a.art > b.art ? 1 : -1;
        } else if (sortList.get(column) === -1) {
          return a.art > b.art ? -1 : 1;
        } else return 0;
      } else if (column === 2) {
        if (sortList.get(column) === 1) {
          return a.status > b.status ? 1 : -1;
        } else if (sortList.get(column) === -1) {
          return a.status > b.status ? -1 : 1;
        } else return 0;
      } else if (column === 3) {
        if (sortList.get(column) === 1) {
          return a.name_endkunde > b.name_endkunde ? 1 : -1;
        } else if (sortList.get(column) === -1) {
          return a.name_endkunde > b.name_endkunde ? -1 : 1;
        } else return 0;
      } else if (column === 4) {
        if (sortList.get(column) === 1) {
          return a.stadt_lieferadresse > b.stadt_lieferadresse ? 1 : -1;
        } else if (sortList.get(column) === -1) {
          return a.stadt_lieferadresse > b.stadt_lieferadresse ? -1 : 1;
        } else return 0;
      } else if (column === 5) {
        const dateA = a.aktuellerTermin ? new Date(a.aktuellerTermin).getTime() : 0;
        const dateB = b.aktuellerTermin ? new Date(b.aktuellerTermin).getTime() : 0;
        if (sortList.get(column) === 1) {
          return dateA - dateB;
        } else if (sortList.get(column) === -1) {
          return dateB - dateA;
        } else return 0;
      } else if (column === 6) {
        const dateA = a.createDate ? new Date(a.createDate).getTime() : 0;
        const dateB = b.createDate ? new Date(b.createDate).getTime() : 0;
        if (sortList.get(column) === 1) {
          return dateA - dateB;
        } else if (sortList.get(column) === -1) {
          return dateB - dateA;
        } else return 0;
      } else return 0;
    });

    setListe([...liste]);
  }

  const getIconBySort = (column: number) => {
    if (sortList.get(column) === -1) {
      return "bi bi-arrow-down";
    } else if (sortList.get(column) === 1) {
      return "bi bi-arrow-up";
    } else {
      return "bi bi-arrow-down-up";
    }
  }

  const suche = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchTerm = e.target.value.toLowerCase();

    if (searchTerm === "") {
      setListe(originalListe);
      return;
    }

    var liste1 = originalListe.filter(auftrag =>
      (auftrag.vorname_endkunde + " " + auftrag.name_endkunde).toLowerCase().includes(searchTerm) ||
      auftrag.stadt_lieferadresse.toLowerCase().includes(searchTerm) ||
      auftrag.art.toLowerCase().includes(searchTerm)
    );
    setListe(liste1);
  }

  const getFarbeZuStatus = (status: string) => {
    if (status === "NEU") {
      return "lightblue";
    } else if (status === "IN_TERMINIERUNG") {
      return "lightblue";
    } else if (status === "IN_TERMINIERUNG") {
      return "yellow";
    } else if (status === "FERTIG") {
      return "lightgreen";
    } else
      return "white";
  }

  const saveColumnOrder = () => {
    var dto: IAuftragTableOrderColumns = {
      art: sortList.get(1) || 0,
      status: sortList.get(2) || 0,
      name: sortList.get(3) || 0,
      lieferort: sortList.get(4) || 0,
      termin: sortList.get(5) || 0,
      erstellt_am: sortList.get(6) || 0,
    }

    setProfileParameter({
      key: "eigeneauftraegetablesort",
      value: JSON.stringify(dto)
    }).catch((error) => {
      console.error("Error saving column order:", error);
    });
  }

  useEffect(() => {
    setListe(originalListe.slice());
  }, [originalListe]);

  useEffect(() => {
    sortList.forEach((value, key) => {
      if (value !== 0) {
        console.log("Sorting by column:", key, "with value:", value);
        sortListeByColumn(key);
      }
    });

  }, [sortList]);

  const lade = () => {
    setIsLoading(true);
    eigeneauftraegeAPI().unwrap()
      .then((data) => setOriginalListe(data))
      .catch((error) => console.log(error))
      .finally(() => setIsLoading(false))
      ;

    getProfileParameter("eigeneauftraegetablesort").unwrap().then((dto) => {
      if (dto) {
        setSortList(new Map([
          [1, dto.art], // Art
          [2, dto.status], // Status
          [3, dto.name], // Name
          [4, dto.lieferort], // Lieferort
          [5, dto.termin], // Termin
          [6, dto.erstellt_am]  // Erstellt am
        ]));
      }
    }).catch((error) => {
      setSortList(new Map([
        [1, 0], // Art
        [2, 0], // Status
        [3, 0], // Name
        [4, 0], // Lieferort
        [5, 0], // Termin
        [6, 0]  // Erstellt am
      ]));
    });
  }

  const handleVisibilityChange = (uid: string, visible: boolean) => {
    changeVisibilityAPI({ uid, visible }).unwrap()
      .then(() => {
        // Nach erfolgreicher Änderung die Liste neu laden
        lade();
      })
      .catch((error) => console.log(error))
    ;
    
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    lade();
  }, []);

  return (

    <div>

      <LoadingModal show={isLoading} />

      <h3>{t('deTranslation.eigeneAuftraege.titel')}</h3>
      
      {liste?.length === 0 && <div>Keine Aufträge vorhanden</div>}

      {liste?.length !== 0 && <p>
        Anzahl {liste.length}
      </p>}

      Suche : <input type="text" className='form-control' placeholder='Suche' onChange={suche} />

      <table className="table table-striped">
        <thead>
          <tr>
            <th onClick={() => { sort(1) }}>Art <i style={{ marginLeft: "10px" }} className={getIconBySort(1)} /></th>
            <th onClick={() => { sort(2) }}>Status <i style={{ marginLeft: "10px" }} className={getIconBySort(2)} /></th>
            <th onClick={() => { sort(3) }}>Name <i style={{ marginLeft: "10px" }} className={getIconBySort(3)} /></th>
            <th onClick={() => { sort(4) }}>Lieferort <i style={{ marginLeft: "10px" }} className={getIconBySort(4)} /></th>
            <th onClick={() => { sort(5) }}>Termin <i style={{ marginLeft: "10px" }} className={getIconBySort(5)} /></th>
            <th onClick={() => { sort(6) }}>Erstellt am <i style={{ marginLeft: "10px" }} className={getIconBySort(6)} /></th>
            <th>Option</th>
          </tr>
        </thead>
        <tbody>
          {
            liste?.slice().map((e, index) => (
              <tr key={e.uid} >
                <td style={{ padding: "12px 16px" }}>{e.art}</td>
                <td style={{ padding: "12px 16px" }}><label style={{ borderRadius: "10px", border: "none", padding: "10px", backgroundColor: getFarbeZuStatus(e.status) }}>{e.status}</label></td>
                <td style={{ padding: "12px 16px" }}>{e.vorname_endkunde} {e.name_endkunde}</td>
                <td style={{ padding: "12px 16px" }}>{e.stadt_lieferadresse}</td>
                <td style={{ padding: "12px 16px" }}>{getWochentagUtil(e.aktuellerTermin)} {formatToEuroDate(e.aktuellerTermin)}</td>
                <td style={{ padding: "12px 16px" }}>{getWochentagUtil(e.createDate)} {formatToEuroDate(e.createDate)}</td>
                <td style={{ padding: "12px 16px" }}>
                  <button title='Details ansehen' className="btn btn-outline-secondary" onClick={() => navigate("eigeneauftraege/detail/" + e.uid)}><i title="Details ansehen" style={{ cursor: "pointer", fontSize: "18pt" }} className="bi bi-pencil"></i></button>
                  <button title='Duplizieren' className="btn btn-outline-secondary" onClick={() => navigate("neuerauftrag", { state: { action: 'copy', uid: e.uid } })}><i title="Duplizieren" style={{ cursor: "pointer", fontSize: "18pt" }} className="bi bi-copy"></i></button>
                  <button title='Ausblenden' className="btn btn-outline-secondary" onClick={() => handleVisibilityChange(e.uid , false )}><i title="Ausblenden" style={{ cursor: "pointer", fontSize: "18pt" }} className="bi bi-eye-slash"></i></button>
                </td>
              </tr>
            ))
          }
        </tbody >
      </table >

      <ScrollToTopBadge />

    </div >
  );

}
function getAuftragMessagesListe(): [any] {
  throw new Error('Function not implemented.');
}

